<template>
    <loader v-if="loading" />
    <div class="distribution" v-else>
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs grow icons-and-text show-arrows v-model="$store.state.distribution.level">
                        <v-tab v-for="(level, index) in levels" :key="index">
                            {{ level.name }}
                            <div>
                                <v-icon v-if="index === 0" small>
                                    fa-graduation-cap
                                </v-icon>
                                <v-icon v-else small v-for="icon in Array(index)" :key="icon">
                                    fa-star
                                </v-icon>
                            </div>
                        </v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn-toggle
                    v-if="$route.name === 'DistributionAgents'"
                    mandatory
                    v-model="$store.state.distribution.date"
                    class="mr-4"
                >
                    <v-btn value="yesterday">I går</v-btn>
                    <v-btn value="today">I dag</v-btn>
                </v-btn-toggle>
                <v-btn-toggle
                    v-if="access === 'admin' || access === 'all' || access === 'quality'"
                    mandatory
                    v-model="$store.state.distribution.department"
                >
                    <v-btn>Tryg</v-btn>
                    <v-btn>Alka</v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <router-view />
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: true
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('distribution/config')
            this.$store.state.distribution.settings = response.data
            this.loading = false
        }
    },
    created () {
        this.getData()
    },
    computed: {
        levels () {
            return this.$store.getters['distribution/settings'].levels
        },
        access () {
            return this.$store.state.main.access
        }
    }
}
</script>